import navigateToNextWhatsappPageAction from "@actions/navigateToNextWhatsappPageAction"
import isUserSignedInLoader from "@loaders/isUserSignedInLoader"
import skipOnboardingLoader from "@loaders/skipOnboardingLoader"
import ActivityLevel from "@pages/onboarding/ActivityLevel"
import Age from "@pages/onboarding/Age"
import CalorieCountingExperience from "@pages/onboarding/CalorieCountingExperience"
import ChooseGoal from "@pages/onboarding/ChooseGoal"
import Gender from "@pages/onboarding/Gender"
import GoalReason from "@pages/onboarding/GoalReason"
import GoalWeight from "@pages/onboarding/GoalWeight"
import Height from "@pages/onboarding/Height"
import ProgressPlan from "@pages/onboarding/ProgressPlan"
import Weight from "@pages/onboarding/Weight"
import WellnessSnapshot from "@pages/onboarding/WellnessSnapshot"
import WhatsAppCoaching from "@pages/onboarding/WhatsAppCoaching"
import WhatsAppTracking from "@pages/onboarding/WhatsAppTracking"
import EmailPage from "@pages/signUp/EmailPage"
import PasswordPage from "@pages/signUp/PasswordPage"
import { Navigate, Outlet } from "react-router-dom"
import CoachingFeatures from "./CoachingFeatures"
import IdealTracking from "./IdealTracking"
import MessagingStyle from "./MessagingStyle"
import ReminderPreference from "./ReminderPreference"
import TrackingChallenges from "./TrackingChallenges"
import WhatsAppUsage from "./WhatsAppUsage"
import { WHATSAPP_STEPS } from "./whatsappSteps"

const STEP_COMPONENTS: Record<string, React.ComponentType> = {
  chooseGoal: Gender,
  mainGoal: ChooseGoal,
  goalReason: GoalReason,
  calorieCountingExperience: CalorieCountingExperience,
  trackingChallenges: TrackingChallenges,
  idealTracking: IdealTracking,
  whatsAppUsage: WhatsAppUsage,
  messagingStyle: MessagingStyle,
  whatsAppDemo: WhatsAppTracking,
  reminderPreference: ReminderPreference,
  coachingFeatures: CoachingFeatures,
  whatsAppCoachingDemo: WhatsAppCoaching,
  height: Height,
  weight: Weight,
  goalWeight: GoalWeight,
  age: Age,
  activityLevel: ActivityLevel,
  wellnessSnapshot: WellnessSnapshot,
  progressPlan: ProgressPlan,
  password: PasswordPage,
  email: EmailPage,
}

const STEPS_WITHOUT_ACTION = ["email", "password"]
const AUTH_STEPS = ["email", "password"]

export function createWhatsappRoutes() {
  const childRoutes = WHATSAPP_STEPS.map((step) => {
    const Component = STEP_COMPONENTS[step]
    const useAction = !STEPS_WITHOUT_ACTION.includes(step)
    const useAuthLoader = AUTH_STEPS.includes(step)

    return {
      path: step,
      element: <Component />,
      ...(useAction && { action: navigateToNextWhatsappPageAction }),
      ...(useAuthLoader && { loader: isUserSignedInLoader }),
    }
  })

  return [
    {
      path: "/onboarding/whatsapp",
      element: <Outlet />,
      children: [
        {
          index: true,
          loader: skipOnboardingLoader,
          element: (
            <Navigate to={`chooseGoal${window.location.search}`} replace />
          ),
        },
        ...childRoutes,
      ],
    },
  ]
}
